/** Soft vertical tint aligned with headline lavender (#b7a8ea). */
export const PRIMARY_BUTTON_FILL =
  "linear-gradient(180deg, #ffffff 0%, #f0ecf8 100%)";

export const primaryButtonLabelClass = "text-[#0D004D]";

/** Promotes buttons to a compositor layer before hover scale to avoid momentary blur. */
export const primaryButtonScaleLayerClass = "will-change-transform";
